/* eslint-disable react-hooks/exhaustive-deps */

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import React, { useEffect } from "react";

import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";
import DateFnsUtils from "@date-io/date-fns";
import { TextMaskCustom } from "../../curriculumVitae/help";
import Utils from "../../../utils/utils";
import deLocale from "date-fns/locale/es";
import moment from "moment";
import { stylesGenContract } from "../stylesGenContract";
import { useStateValue } from "../../../context/store";

const InfoContract = ({
  inforContract,
  onChangeInfoContract,
  onSubmit,
  charges,
  department,
  citys,
  handleDepartment,
  inputDisabled,
  contract,
  company,
  dataUser,
  handleDepartmentResidence,
  citysResidence,
  maestras,
  professions,
  regionals,
  disableFinalDate,
  disableSalary,
  isContractApprenti,
  isSena,
  setIsSena,
  idContract,
  setValue,
  handleSubmit,
  errors,
  control,
  register,
  stateSalary,
  isObraLaborFieldsDisabled,
  setProfessionList,
  professionList,
  getProfessionByValue,
  messageErrorProfession,
  setChargesList,
  chargesList,
  isLaborDisable,
}) => {
  const [{}, dispatch] = useStateValue();
  const classes = stylesGenContract();
  const maxDate = Utils.getFormattedDateMMddyyyy(new Date(), ".");

  const getContract = () => {
    if (dataUser?.data && !idContract) {
      const filterDepartment = department.filter(
        (x) => x?.name === dataUser?.data?.provinceResidence
      );
      const departmentResidence = filterDepartment.map((x) => x?.id).toString();
      setValue("firstName", dataUser?.data?.firstName);
      setValue(
        "secondName",
        dataUser?.data?.secondName ? dataUser?.data?.secondName : null
      );
      setValue("surname", dataUser?.data?.surname);
      setValue(
        "secondSurname",
        dataUser?.data?.secondSurname ? dataUser?.data?.secondSurname : null
      );
      setValue("dateBirth", moment(dataUser?.data?.dateBirth).format());
      setValue("charge", dataUser?.data?.lastChargePostulatedVacancy?.id);
      setValue(
        "regionalId",
        dataUser?.data?.lastRegionalPostulatedRequisition?.id
      );
      setValue("formationLevel", dataUser?.data?.levelFormation);
      setValue("profession", dataUser?.data?.profession);
      setValue("employeeNameToReplace", dataUser?.data?.employeeNameToReplace);
      setValue("chargeIdToReplace", dataUser?.data?.chargeIdToReplace);
      setValue("reasonForReplacement", dataUser?.data?.reasonForReplacement);
      setValue("cellPhoneNumber", dataUser?.data?.cellPhoneNumber);
      setValue("phoneUser", dataUser?.data?.phone);
      setValue("departmentResidence", departmentResidence);
    }
  };

  useEffect(() => {
    if (isContractApprenti) {
      setValue("personalEmail", dataUser?.data?.externalEmail);
    } else {
      setValue("personalEmail", "");
    }
  }, [isContractApprenti, dataUser, setValue]);

  useEffect(() => {
    getContract();
    if (!disableSalary) {
      setValue("salary", dataUser?.data?.salaryLastVacancy);
    } else {
      setValue("salary", "");
    }
  }, [disableSalary, dataUser]);

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Contratos |  Generar contrato",
      breadCrumbSubText: "Generar contrato",
      index: 331,
      subPath: `/dashboard/contracts`,
      submitContract: true,
    });
  }, [dispatch]);

  const handleUserKeyPress = (e) => {
    let invalidChars = ["-", "e", "+", "E", ".", ","];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }

    const { value, name } = e.target;
    const newValue = value
      .replace(/\s+/g, "")
      .split(" ")
      .join("")
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "")
      .trim();
    if (name === "phone" && parseInt(newValue) < 999999999) {
      //setShowTelephoneMessage(true);
    } else {
      //setShowTelephoneMessage(false);
    }
  };

  const handleSalaryKeyPress = (e) => {
    let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    if (!validChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const addDots = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

  const addValuesToMemory = (e) => {
    const { name, value } = e.target;

    let sal = addDots(removeNonNumeric(value));
    setValue("salary", sal);
  };

  const estratos = [
    { id: "1", value: 1 },
    { id: "2", value: 2 },
    { id: "3", value: 3 },
    { id: "4", value: 4 },
    { id: "5", value: 5 },
    { id: "6", value: 6 },
  ];

  const handleChangeChecked = (e) => {
    setIsSena(e.target.checked);
  };

  return (
    <div>
      <form
        id="generateContract"
        onSubmit={handleSubmit(onSubmit)}
        className={classes.form}
      >
        <Grid container spacing={2}>
          <Grid container>
            <Typography
              component="h6"
              variant="h6"
              className={classes.titleContractor}
            >
              Información del contratista
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("firstName") &&
                errors["firstName"].message
              }
            >
              <Controller
                name="firstName"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="firstName"
                    onChange={(e) => onChangeInfoContract(e)}
                    label="Primer nombre *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputForm}
                    error={
                      errors.hasOwnProperty("firstName") &&
                      errors["firstName"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("secondName") &&
                errors["secondName"].message
              }
            >
              <Controller
                name="secondName"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="secondName"
                    onChange={(e) => onChangeInfoContract(e)}
                    label="Segundo nombre"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputForm}
                    error={
                      contract?.secondName === ""
                        ? null
                        : errors.hasOwnProperty("secondName") &&
                          errors["secondName"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {contract?.secondName === ""
                  ? null
                  : errors.hasOwnProperty("secondName") &&
                    errors["secondName"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("surname") && errors["surname"].message
              }
            >
              <Controller
                name="surname"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="surname"
                    onChange={(e) => onChangeInfoContract(e)}
                    label="Primer apellido *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputForm}
                    error={
                      errors.hasOwnProperty("surname") &&
                      errors["surname"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("surname") && errors["surname"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("secondSurname") &&
                errors["secondSurname"].message
              }
            >
              <Controller
                name="secondSurname"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="secondSurname"
                    onChange={(e) => onChangeInfoContract(e)}
                    label="Segundo apellido"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputForm}
                    error={
                      contract.secondSurname === ""
                        ? null
                        : errors.hasOwnProperty("secondSurname") &&
                          errors["secondSurname"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {contract.secondSurname === ""
                  ? null
                  : errors.hasOwnProperty("secondSurname") &&
                    errors["secondSurname"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("department") &&
                errors["department"].message
              }
            >
              <InputLabel htmlFor="outlined-select-department" shrink={true}>
                Departamento de nacimiento *
              </InputLabel>
              <Controller
                fullWidth
                name="department"
                control={control}
                size="small"
                defaultValue=""
                render={(props) => (
                  <Select
                    inputRef={register}
                    label="Departamento de nacimiento *"
                    notched={true}
                    className={classes.inputForm}
                    size="small"
                    inputProps={{
                      name: "department",
                      id: "outlined-select-department",
                    }}
                    defaultValue=""
                    value={props.value}
                    onChange={(e) => {
                      props.onChange(e);
                      handleDepartment(e);
                    }}
                  >
                    {department?.map((resp) => (
                      <MenuItem
                        key={resp?.id}
                        value={resp?.id}
                        className={classes.menuItem}
                      >
                        {resp?.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("department") &&
                  errors["department"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("municipality") &&
                errors["municipality"].message
              }
            >
              <InputLabel htmlFor="outlined-select-municipality" shrink={true}>
                Municipio de nacimiento *
              </InputLabel>
              <Controller
                fullWidth
                name="municipality"
                control={control}
                size="small"
                defaultValue=""
                render={(props) => (
                  <Select
                    inputRef={register}
                    label="Municipio de nacimiento *"
                    notched={true}
                    className={classes.inputForm}
                    size="small"
                    inputProps={{
                      name: "municipality",
                      id: "outlined-select-municipality",
                    }}
                    value={props.value}
                    onChange={(e) => {
                      props.onChange(e);
                      onChangeInfoContract(e);
                    }}
                  >
                    {citys?.map((res) => (
                      <MenuItem
                        key={res?.id}
                        value={res?.name}
                        className={classes.menuItem}
                      >
                        {" "}
                        {res?.name}{" "}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("municipality") &&
                  errors["municipality"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} className={classes.formControlGen}>
            <FormControl fullWidth>
              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                <Controller
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      inputVariant="outlined"
                      variant="inline"
                      name="dateBirth"
                      className={classes.inputForm}
                      format="dd/MM/yyyy"
                      dateFormat="dd/MM/yyyy"
                      label="Fecha de nacimiento *"
                      InputLabelProps={{ shrink: true }}
                      onChange={onChangeInfoContract}
                      error={
                        !!errors.hasOwnProperty("dateBirth") &&
                        errors["dateBirth"].message
                      }
                      helperText={
                        !!errors.hasOwnProperty("dateBirth") &&
                        errors["dateBirth"].message
                      }
                      minDate={"01.01.1900"}
                      minDateMessage={"No puede ser menor a 1900"}
                      maxDate={maxDate}
                    />
                  }
                  control={control}
                  name="dateBirth"
                  placeholder="dd/mm/yyyy"
                  size="small"
                  defaultValue={null}
                />
              </MuiPickersUtilsProvider>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("nationality") &&
                errors["nationality"].message
              }
            >
              <Controller
                name="nationality"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="nationality"
                    onChange={onChangeInfoContract}
                    label="Nacionalidad *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    inputRef={register}
                    className={classes.inputForm}
                    error={
                      errors.hasOwnProperty("nationality") &&
                      errors["nationality"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("nationality") &&
                  errors["nationality"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("departmentResidence") &&
                errors["departmentResidence"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-departmentResidence"
                shrink={true}
              >
                Departamento de residencia *
              </InputLabel>
              <Controller
                fullWidth
                name="departmentResidence"
                control={control}
                size="small"
                defaultValue=""
                render={(props) => (
                  <Select
                    inputRef={register}
                    label="Departamento de residencia *"
                    notched={true}
                    className={classes.inputForm}
                    size="small"
                    inputProps={{
                      name: "departmentResidence",
                      id: "outlined-select-departmentResidence",
                    }}
                    value={props.value}
                    onChange={(e) => {
                      props.onChange(e);
                      handleDepartmentResidence(e);
                    }}
                  >
                    {department?.map((resp) => (
                      <MenuItem
                        key={resp?.id}
                        value={resp?.id}
                        className={classes.menuItem}
                      >
                        {" "}
                        {resp?.name}{" "}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("departmentResidence") &&
                  errors["departmentResidence"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("cityResidence") &&
                errors["cityResidence"].message
              }
            >
              <InputLabel htmlFor="outlined-select-cityResidence" shrink={true}>
                Municipio de residencia *
              </InputLabel>
              <Controller
                fullWidth
                name="cityResidence"
                control={control}
                size="small"
                defaultValue=""
                render={(props) => (
                  <Select
                    inputRef={register}
                    label="Municipio de residencia *"
                    notched={true}
                    className={classes.inputForm}
                    size="small"
                    inputProps={{
                      name: "cityResidence",
                      id: "outlined-select-cityResidence",
                    }}
                    value={props.value}
                    onChange={(e) => {
                      props.onChange(e);
                      onChangeInfoContract(e);
                    }}
                  >
                    {citysResidence?.map((res) => (
                      <MenuItem
                        key={res?.id}
                        value={res?.name}
                        className={classes.menuItem}
                      >
                        {" "}
                        {res?.name}{" "}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("cityResidence") &&
                  errors["cityResidence"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("documentIssuancePlace") &&
                errors["documentIssuancePlace"].message
              }
            >
              <Controller
                name="documentIssuancePlace"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="documentIssuancePlace"
                    onChange={(e) => onChangeInfoContract(e)}
                    label="Lugar de expedición cédula *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputForm}
                    error={
                      errors.hasOwnProperty("documentIssuancePlace") &&
                      errors["documentIssuancePlace"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("documentIssuancePlace") &&
                  errors["documentIssuancePlace"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("address") && errors["address"].message
              }
            >
              <Controller
                name="address"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="address"
                    onChange={onChangeInfoContract}
                    label="Dirección del empleado *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    className={classes.inputForm}
                    inputRef={register}
                    error={
                      errors.hasOwnProperty("address") &&
                      errors["address"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("address") && errors["address"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
            <Controller
              name="profession"
              control={control}
              render={(props) => (
                <Autocomplete
                  {...props}
                  freeSolo
                  value={professionList}
                  size="small"
                  options={professions}
                  className={classes.formFieldAutocomplete}
                  getOptionLabel={(option) => option?.occupation}
                  renderOption={(option) => option?.occupation}
                  defaultValue={props.value}
                  onChange={(e, newval) => {
                    setProfessionList(newval);
                    props.onChange(e);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Profesión *"
                      variant="outlined"
                      inputRef={register}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          height: "16px",
                          borderRadius: "8px",
                          paddingBottom: "6.5px",
                          fontSize: 14,
                        },
                      }}
                      error={
                        messageErrorProfession
                          ? messageErrorProfession
                          : !!errors.hasOwnProperty("profession") &&
                            errors["profession"].message
                      }
                      helperText={
                        messageErrorProfession
                          ? messageErrorProfession
                          : errors.hasOwnProperty("profession") &&
                            errors["profession"].message
                      }
                      onChange={(e) => getProfessionByValue(e, "empty")}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("formationLevel") &&
                errors["formationLevel"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-formationLevel"
                shrink={true}
              >
                Nivel de Formación *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="formationLevel"
                inputRef={register}
                defaultValue=""
                className={classes.inputForm}
                label="Nivel de Formación *"
                size="small"
                notched={true}
                inputProps={{
                  name: "formationLevel",
                  id: "outlined-select-formationLevel",
                }}
                as={
                  <Select>
                    {maestras?.nivelFormacion?.map((res) => (
                      <MenuItem
                        key={res}
                        value={res}
                        className={classes.menuItem}
                      >
                        {res}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("formationLevel") &&
                  errors["formationLevel"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("regionalId") &&
                errors["regionalId"].message
              }
            >
              <InputLabel htmlFor="outlined-select-regionalId" shrink={true}>
                Regional *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="regionalId"
                inputRef={register}
                defaultValue=""
                className={classes.inputForm}
                label="Regional *"
                size="small"
                notched={true}
                inputProps={{
                  name: "regionalId",
                  id: "outlined-select-regionalId",
                }}
                as={
                  <Select>
                    {regionals.map((res) => (
                      <MenuItem
                        key={res?.id}
                        value={res?.id}
                        className={classes.menuItem}
                      >
                        {res.name}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("regionalId") &&
                  errors["regionalId"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3} style={{ marginTop: "8px" }}>
            <FormControl
              fullWidth
              //style={{ marginTop: "0px" }}
              error={
                !!errors.hasOwnProperty("cellPhoneNumber") &&
                errors["cellPhoneNumber"].message
              }
            >
              <InputLabel
                htmlFor="cellPhoneNumber"
                style={{
                  zIndex: 2,
                  marginTop: "-15px",
                  paddingLeft: "10px",
                }}
              >
                No. Celular *
              </InputLabel>
              <Input
                id="cellPhoneNumber"
                inputComponent={TextMaskCustom}
                variant="outlined"
                //className={classes.dropdown}
                type="text"
                notched={true}
                inputRef={register}
                className={classes.formField}
                style={{ marginTop: "0px" }}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "0px",
                    fontSize: 14,
                    paddingLeft: "12px",
                  },
                }}
                onKeyPress={handleUserKeyPress}
                name="cellPhoneNumber"
                size="small"
              />
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("cellPhoneNumber") &&
                  errors["cellPhoneNumber"].message}
              </FormHelperText>
              <FormHelperText style={{ color: "#f44336" }}>
                {!errors.hasOwnProperty("cellPhoneNumber")}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3} style={{ marginTop: "8px" }}>
            <FormControl
              fullWidth
              style={{ marginTop: "0px" }}
              error={
                !!errors.hasOwnProperty("phoneUser") &&
                errors["phoneUser"].message
              }
            >
              <InputLabel
                htmlFor="phoneUser"
                style={{
                  zIndex: 2,
                  marginTop: "-7px",
                  paddingLeft: "10px",
                }}
              >
                No. Teléfono
              </InputLabel>
              <Input
                id="phoneUser"
                inputComponent={TextMaskCustom}
                variant="outlined"
                type="text"
                notched={true}
                inputRef={register}
                className={classes.formField}
                name="phoneUser"
                style={{ marginTop: "0px" }}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "0px",
                    fontSize: 14,
                    paddingLeft: "12px",
                  },
                }}
                onKeyPress={handleUserKeyPress}
                size="small"
              />
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("phoneUser") &&
                  errors["phoneUser"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("gender") && errors["gender"].message
              }
            >
              <InputLabel htmlFor="outlined-select-gender" shrink={true}>
                Género *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="gender"
                inputRef={register}
                defaultValue=""
                className={classes.inputForm}
                label="Género *"
                size="small"
                notched={true}
                inputProps={{
                  name: "gender",
                  id: "outlined-select-gender",
                }}
                as={
                  <Select>
                    {maestras?.generos?.map((res) => (
                      <MenuItem
                        key={res.key}
                        value={res.key}
                        className={classes.menuItem}
                      >
                        {res.value}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("gender") && errors["gender"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>

        {isContractApprenti ? (
          <Grid
            container
            spacing={2}
            style={{ marginTop: 10, marginBottom: 10 }}
          >
            <Grid container>
              <Typography
                component="h6"
                variant="h6"
                className={classes.titleContractor}
              >
                Información del aprendiz
              </Typography>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControlGen}
                size="small"
                error={
                  isContractApprenti
                    ? !!errors.hasOwnProperty("stratus") &&
                      errors["stratus"].message
                    : null
                }
              >
                <InputLabel htmlFor="outlined-select-stratus" shrink={true}>
                  {" "}
                  Estrato *
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  name="stratus"
                  inputRef={register}
                  defaultValue=""
                  className={classes.inputForm}
                  label="Estrato *"
                  size="small"
                  notched={true}
                  inputProps={{
                    name: "stratus",
                    id: "outlined-select-stratus",
                  }}
                  as={
                    <Select>
                      {estratos.map((res) => (
                        <MenuItem
                          key={res?.id}
                          value={res?.id}
                          className={classes.menuItem}
                        >
                          {res.value}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {isContractApprenti
                    ? errors.hasOwnProperty("stratus") &&
                      errors["stratus"].message
                    : null}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="text"
                  name="specialty"
                  defaultValue=""
                  className={classes.inputForm}
                  label="Especialidad o curso *"
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                  error={
                    isContractApprenti
                      ? errors.hasOwnProperty("specialty") &&
                        errors["specialty"].message
                      : null
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {isContractApprenti
                    ? errors.hasOwnProperty("specialty") &&
                      errors["specialty"].message
                    : null}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="number"
                  name="groupNumber"
                  defaultValue=""
                  className={classes.inputForm}
                  label="Número de grupo"
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                  onKeyPress={handleUserKeyPress}
                  error={
                    isContractApprenti
                      ? errors.hasOwnProperty("groupNumber") &&
                        errors["groupNumber"].message
                      : null
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {isContractApprenti
                    ? errors.hasOwnProperty("groupNumber") &&
                      errors["groupNumber"].message
                    : null}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  className={classes.inputForm}
                  inputRef={register}
                  label="Correo electrónico *"
                  name="personalEmail"
                  size="small"
                  margin="dense"
                  placeholder="ejemplo@correo.com"
                  InputLabelProps={{ shrink: true }}
                  error={
                    isContractApprenti
                      ? !!errors.hasOwnProperty("personalEmail") &&
                        errors["personalEmail"].message
                      : null
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {isContractApprenti
                    ? errors.hasOwnProperty("personalEmail") &&
                      errors["personalEmail"].message
                    : null}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="text"
                  name="eps"
                  defaultValue=""
                  className={classes.inputForm}
                  label="EPS *"
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                  error={
                    isContractApprenti
                      ? errors.hasOwnProperty("eps") && errors["eps"].message
                      : null
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {isContractApprenti
                    ? errors.hasOwnProperty("eps") && errors["eps"].message
                    : null}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="text"
                  name="arl"
                  defaultValue=""
                  className={classes.inputForm}
                  label="ARL *"
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                  error={
                    isContractApprenti
                      ? errors.hasOwnProperty("arl") && errors["arl"].message
                      : null
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {isContractApprenti
                    ? errors.hasOwnProperty("arl") && errors["arl"].message
                    : null}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="text"
                  name="trainingInstitutionNit"
                  defaultValue=""
                  className={classes.inputForm}
                  label="NIT"
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                  error={
                    isContractApprenti
                      ? errors.hasOwnProperty("trainingInstitutionNit") &&
                        errors["trainingInstitutionNit"].message
                      : null
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {isContractApprenti
                    ? errors.hasOwnProperty("trainingInstitutionNit") &&
                      errors["trainingInstitutionNit"].message
                    : null}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="text"
                  name="trainingInstitution"
                  defaultValue=""
                  className={classes.inputForm}
                  label="Institución de formación *"
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                  error={
                    isContractApprenti
                      ? errors.hasOwnProperty("trainingInstitution") &&
                        errors["trainingInstitution"].message
                      : null
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {isContractApprenti
                    ? errors.hasOwnProperty("trainingInstitution") &&
                      errors["trainingInstitution"].message
                    : null}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid container>
              <Grid item xs={12} md={1} lg={1} style={{ paddingLeft: 10 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      name="checkBox"
                      checked={isSena}
                      value={isSena}
                      onChange={(e) => handleChangeChecked(e)}
                    />
                  }
                  label="SENA"
                />
              </Grid>

              {isSena ? (
                <Grid item xs={12} md={11} lg={11} style={{ paddingRight: 10 }}>
                  <FormControl fullWidth>
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      inputRef={register}
                      type="text"
                      name="trainingCenter"
                      defaultValue=""
                      className={classes.inputForm}
                      label="Centro de formación *"
                      variant="outlined"
                      fullWidth
                      size="small"
                      margin="dense"
                      error={
                        isContractApprenti && isSena
                          ? errors.hasOwnProperty("trainingCenter") &&
                            errors["trainingCenter"].message
                          : null
                      }
                    />
                    <FormHelperText
                      style={{ color: "#f44336", paddingLeft: 14 }}
                    >
                      {isContractApprenti && isSena
                        ? errors.hasOwnProperty("trainingCenter") &&
                          errors["trainingCenter"].message
                        : null}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        ) : null}

        <Grid container spacing={2}>
          <Grid container>
            <Typography
              component="h6"
              variant="h6"
              className={classes.titleContractor}
            >
              Información del contrato
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("charge") && errors["charge"].message
              }
            >
              <InputLabel htmlFor="outlined-select-charge" shrink={true}>
                Cargo a desempeñar *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="charge"
                inputRef={register}
                defaultValue=""
                className={classes.inputForm}
                label="Cargo a desempeñar *"
                size="small"
                notched={true}
                inputProps={{
                  name: "charge",
                  id: "outlined-select-charge",
                }}
                as={
                  <Select>
                    {charges?.map((res) => (
                      <MenuItem
                        key={res?.id}
                        value={res?.id}
                        className={classes.menuItem}
                      >
                        {res.denomination}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("charge") && errors["charge"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              fullWidth
              size="small"
              className={
                disableSalary ? classes.inputDisabled : classes.formField
              }
              style={{ marginBottom: "0px", marginTop: "8px" }}
              variant="outlined"
              error={
                !!errors.hasOwnProperty("salary") && errors["salary"].message
              }
            >
              <InputLabel htmlFor="outlined-adornment-amount">
                Salario *
              </InputLabel>
              <OutlinedInput
                size="small"
                name="salary"
                inputRef={register}
                id="outlined-adornment-amount"
                inputProps={{ maxLength: 11 }}
                onKeyPress={handleSalaryKeyPress}
                onChange={addValuesToMemory}
                disabled={disableSalary ? true : false}
                startAdornment={
                  <InputAdornment position="start">$</InputAdornment>
                }
                labelWidth={60}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {stateSalary
                  ? null
                  : errors.hasOwnProperty("salary") && errors["salary"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("paymentPeriod") &&
                errors["paymentPeriod"].message
              }
            >
              <InputLabel htmlFor="outlined-select-paymentPeriod" shrink={true}>
                Periodos de pago *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="paymentPeriod"
                size="small"
                defaultValue=""
                className={classes.inputForm}
                label="Periodos de pago *"
                inputRef={register}
                notched={true}
                onChange={(e) => {
                  onChangeInfoContract(e);
                }}
                inputProps={{
                  name: "paymentPeriod",
                  id: "outlined-select-paymentPeriod",
                }}
                as={
                  <Select>
                    <MenuItem value="Mensual" className={classes.menuItem}>
                      Mensual
                    </MenuItem>
                    <MenuItem value="Quincenal" className={classes.menuItem}>
                      Quincenal
                    </MenuItem>
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("paymentPeriod") &&
                  errors["paymentPeriod"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item md={3}></Grid>
          <Grid item xs={12} md={3} className={classes.formControlGen}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                control={control}
                name="workStartDate"
                placeholder="dd/mm/yyyy"
                size="small"
                defaultValue={null}
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputRef={register}
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy"
                    onChange={onChangeInfoContract}
                    className={classes.inputForm}
                    label="Inicio de labores *"
                    InputLabelProps={{ shrink: true }}
                    error={
                      contract?.workStartDate === null
                        ? null
                        : !!errors.hasOwnProperty("workStartDate") &&
                          errors["workStartDate"].message
                    }
                    helperText={
                      contract?.startOfWork === null
                        ? null
                        : errors.hasOwnProperty("workStartDate") &&
                          errors["workStartDate"].message
                    }
                    minDate={"01.01.1900"}
                    minDateMessage={"No puede ser menor a 1900"}
                    //maxDate={maxDate}
                  />
                }
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("workplace") &&
                errors["workplace"].message
              }
            >
              <Controller
                name="workplace"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="workplace"
                    onChange={onChangeInfoContract}
                    label="Lugar donde desempeñará *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    className={classes.inputForm}
                    inputRef={register}
                    error={
                      errors.hasOwnProperty("workplace") &&
                      errors["workplace"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("workplace") &&
                  errors["workplace"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("hiringPlace") &&
                errors["hiringPlace"].message
              }
            >
              <Controller
                name="hiringPlace"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="hiringPlace"
                    onChange={onChangeInfoContract}
                    label="Lugar donde ha sido contratado *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    className={classes.inputForm}
                    inputRef={register}
                    error={
                      errors.hasOwnProperty("hiringPlace") &&
                      errors["hiringPlace"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("hiringPlace") &&
                  errors["hiringPlace"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} className={classes.formControlGen}>
            <FormControl
              fullWidth
              error={
                !!errors.hasOwnProperty("workEndDate") &&
                errors["workEndDate"].message
              }
            >
              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                <Controller
                  control={control}
                  name="workEndDate"
                  placeholder="dd/mm/yyyy"
                  size="small"
                  defaultValue={null}
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      inputRef={register}
                      inputVariant="outlined"
                      variant="inline"
                      format="dd/MM/yyyy"
                      value={inforContract.workEndDate}
                      onChange={onChangeInfoContract}
                      className={
                        disableFinalDate
                          ? classes.inputDisabled
                          : classes.inputForm
                      }
                      label="Final de labores *"
                      InputLabelProps={{ shrink: true }}
                      disabled={disableFinalDate ? true : false}
                      error={
                        contract?.workEndDate === null
                          ? null
                          : errors.hasOwnProperty("workEndDate") &&
                            errors["workEndDate"].message
                      }
                      helperText={
                        contract?.workEndDate === null
                          ? null
                          : errors.hasOwnProperty("workEndDate") &&
                            errors["workEndDate"].message
                      }
                      minDate={"01.01.1900"}
                      minDateMessage={"No puede ser menor a 1900"}
                      //maxDate={maxDate}
                    />
                  }
                />
              </MuiPickersUtilsProvider>
            </FormControl>
          </Grid>

          <>
            {isObraLaborFieldsDisabled ? (
              <Grid item xs={12} md={3}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={
                    !!errors.hasOwnProperty("employeeNameToReplace") &&
                    errors["employeeNameToReplace"].message
                  }
                >
                  <Controller
                    name="employeeNameToReplace"
                    control={control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        name="employeeNameToReplace"
                        onChange={onChangeInfoContract}
                        label="Colaborador a reemplazar *"
                        variant="outlined"
                        margin="dense"
                        size="small"
                        fullWidth
                        className={classes.inputForm}
                        inputRef={register}
                        error={
                          errors.hasOwnProperty("employeeNameToReplace") &&
                          errors["employeeNameToReplace"].message
                        }
                      />
                    )}
                  />
                  <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                    {errors.hasOwnProperty("employeeNameToReplace") &&
                      errors["employeeNameToReplace"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>
            ) : null}

            {isLaborDisable || isObraLaborFieldsDisabled ? (
              <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
                <Controller
                  name="chargeIdToReplace"
                  control={control}
                  render={(props) => (
                    <Autocomplete
                      {...props}
                      freeSolo
                      value={chargesList}
                      size="small"
                      options={charges}
                      className={classes.formFieldAutocomplete}
                      getOptionLabel={(option) => option?.denomination}
                      renderOption={(option) => option?.denomination}
                      defaultValue={props.value}
                      onChange={(e, newval) => {
                        setChargesList(newval);
                        props.onChange(e);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Cargo a reemplazar"
                          variant="outlined"
                          inputRef={register}
                          InputLabelProps={{ shrink: true }}
                          inputProps={{
                            ...params.inputProps,
                            style: {
                              height: "16px",
                              borderRadius: "8px",
                              paddingBottom: "6.5px",
                              fontSize: 14,
                            },
                          }}
                          error={
                            !!errors.hasOwnProperty("chargeIdToReplace") &&
                            errors["chargeIdToReplace"].message
                          }
                          helperText={
                            errors.hasOwnProperty("chargeIdToReplace") &&
                            errors["chargeIdToReplace"].message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>
            ) : null}

            {isLaborDisable ||
            isObraLaborFieldsDisabled ||
            isContractApprenti ? (
              <Grid item xs={12} md={6}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={
                    !!errors.hasOwnProperty("reasonForReplacement") &&
                    errors["reasonForReplacement"].message
                  }
                >
                  <Controller
                    name="reasonForReplacement"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        name="reasonForReplacement"
                        onChange={onChangeInfoContract}
                        label="Observaciones"
                        variant="outlined"
                        margin="dense"
                        size="small"
                        fullWidth
                        className={classes.inputForm}
                        inputRef={register}
                        error={
                          errors.hasOwnProperty("reasonForReplacement") &&
                          errors["reasonForReplacement"].message
                        }
                      />
                    )}
                  />
                  <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                    {errors.hasOwnProperty("reasonForReplacement") &&
                      errors["reasonForReplacement"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>
            ) : null}
          </>
        </Grid>

        <Grid container spacing={2} style={{ marginTop: "10px" }}>
          <Grid container>
            <Typography
              component="h6"
              variant="h6"
              className={classes.titleContractor}
            >
              Información del empleador
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
            >
              <Controller
                fullWidth
                size="small"
                control={control}
                name="nameEmployer"
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="text"
                    name="nameEmployer"
                    value={company?.name}
                    onChange={onChangeInfoContract}
                    InputLabelProps={{ shrink: true }}
                    label="Nombre del empleador *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    disabled={inputDisabled}
                    className={
                      !inputDisabled ? classes.inputForm : classes.inputDisabled
                    }
                    inputRef={register}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
            >
              <Controller
                fullWidth
                name="numberDocument"
                size="small"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="text"
                    name="numberDocument"
                    value={company?.document}
                    onChange={onChangeInfoContract}
                    InputLabelProps={{ shrink: true }}
                    label="Identificación del empleador *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    disabled={inputDisabled}
                    className={
                      !inputDisabled ? classes.inputForm : classes.inputDisabled
                    }
                    inputRef={register}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
            >
              <Controller
                fullWidth
                name="addressEmployer"
                control={control}
                defaultValue=""
                size="small"
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="text"
                    name="addressEmployer"
                    value={company?.address}
                    onChange={onChangeInfoContract}
                    InputLabelProps={{ shrink: true }}
                    label="Dirección del empleador *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    fullWidth
                    disabled={inputDisabled}
                    className={
                      !inputDisabled ? classes.inputForm : classes.inputDisabled
                    }
                    inputRef={register}
                  />
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default InfoContract;
